import * as React from "react";
import * as ReactDOM from 'react-dom';
import { IOptions } from '../options'
import { SITE_PREFIX } from "../router/urls";
import { FORM_STATUS } from "../const/forms";
import { confirmDialog } from 'primereact/confirmdialog';
import {isUndefined} from "lodash";

export interface Handler {
    (...args: any[]): any;
}

export interface I18NString {
    ru: string,
    en?: string
}

export function isNullOrEmpty(value: string | Array<any>) {
    return value == undefined || value == null || value.length == 0;
}

export let tr: (message: I18NString) => string = function (message: I18NString): string {
    return message.ru;
};

export const breakLine: (text: string) => any = function(text: string): any {
    const regex = /&#13;&#10;/g;
    return text.split(regex).map(function(line, idx) {
        return <span key={idx}>{line}<br/></span>;
    });
};

export function initLanguage(language: string) {
    if(language == null || language.length == 0)
        return;
    language = language.toUpperCase();
    if(language.substr(0, 2) == "EN") {
        tr = function (message: I18NString): string {
            if(message.en !== null && message.en.length > 0)
                return message.en;
            return message.ru;
        }
    }
}

let _incriment = Math.floor(Math.random() * (10000 - 0)) + 10000;
export function getRandomKey() : number  {
    return _incriment++;
}

export abstract class Component<TProp, TState> extends React.Component<TProp, TState> {

    protected tr: (message: I18NString) => string = tr;

    constructor() {
        super();
    }
}

const host = process.env.NODE_ENV === 'production' ?
`${window.location.origin}`:
"http://localhost:3000";


export function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        break;
      }
    }
  }


export function getConfig() : IOptions{
    return {
        process_id: 0,
        form_type: '',
        apiUrl: `${host}${SITE_PREFIX}/public/v1/forms`,
        filesUrl: `${host}${SITE_PREFIX}/public/v1/forms/files`,
        apiUser: `${host}${SITE_PREFIX}/public/v1/users`,
        companyUrl: `${host}${SITE_PREFIX}/public/v1/company`,
        projectsUrl: `${host}${SITE_PREFIX}/public/v1/company/projects`,
        valuesId: Session.getSession(),
        token: "11",
    }
}

export class ActionCreator<T, P> {
    readonly type: T;
    readonly payload: P;

    constructor(type: T) { this.type = type; }
    create = (payload: P) => ({ type: this.type, payload });
  }

export class Session {
    private static session_id: number;

    public static  getSession(): number{
        return this.session_id
    }

    public static setSession(id: number){
        this.session_id = id
    }
}

export function assign(target:any, ...argum:any[]){
    'use strict';

    var output = Object(target);
    for (var index = 1; index < argum.length; index++) {
      var source = argum[index];
      if (source !== undefined && source !== null) {
        for (var nextKey in source) {
          if (source.hasOwnProperty(nextKey)) {
            output[nextKey] = source[nextKey];
          }
        }
      }
    }
    return output;
}

export function goToAnchor(elementId: string): boolean {
    if (elementId !== "") {
        let node = ReactDOM.findDOMNode(document.getElementById(elementId));
        if (node) {
            node.scrollIntoView();
            return true;
        }
    }

    return false;
}

export function getFiletExtension(filename:string){
    return filename.substring(filename.lastIndexOf(".") + 1).toUpperCase();
}


export function checkFileExtension(filename: string, formates: Array<string>): boolean {
    const extension = getFiletExtension(filename);
    //Проверяем формат файла
    return formates.indexOf(extension) !== -1;
}

export class Guid {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }
}

export function clearNonNumberCharacters(str: string): string {
    let decimalSeparatorIndex = 0;
    return str
        .replace(/[^0-9,.-]/g, '') // удаляем все не цифры, не -, не точки с запятыми
        .replace(/(?!^)-/g, '') // удаляем не лидирующие -
        .replace(/[.,]/g, function(match) { // удаляем все точки и запятые кроме первой
            return match === "." || match === "," ? (decimalSeparatorIndex++ === 0 ? match : '') : '';
        });
}

export function numberCommaToDot(str: string): string{
    if(str == null) return null;
    return clearNonNumberCharacters(str).replace(',', '.')
}
export function numberDotToComma(str: string): string{
    if(str == null) return null;
    return clearNonNumberCharacters(str).replace('.', ',')
}

export function strCommaToDot(str:string): string{
    if(str == null) return null;
    return str.replace(',','.')
}

export function parseFloatCommaDot(str:string): number{
    if(str == null) return null;
    return parseFloat(numberCommaToDot(str.toString()))
}

export function numberToFixedString(val:any): string{
    if(val == null) return null;
    let fval = parseFloatCommaDot(val.toString());
    if(isNaN(fval))return null;
    fval = Math.round(fval * 100.0) / 100.0;
    return numberDotToComma(fval.toString())
}

export function roundCurrency(val:number):number{
    if(val == null) return null
    return Math.round(val * 100.0) / 100.0;
}

export function getProcessStatus(item){
    if(item.process_status){
        return item.process_status
    }else{
        if(item.process_completed){
            return 'Завершено'
        }
        return !isUndefined(FORM_STATUS[item.form_status]) ? FORM_STATUS[item.form_status] : 'Неизвестно';
    }
}

export function notify(message:string) {
    return confirmDialog({
        message,
        header: 'Внимание!',
        accept: null,
        reject: null,
        acceptLabel: 'Ок',
        rejectLabel: ' ',
    });
}

export function confirm(message:string, accept:any) {
    return confirmDialog({
        message,
        header: 'Внимание!',
        accept,
        reject: null,
        acceptLabel: 'Ок',
        rejectLabel: 'Отменить',
    });
}
